/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSuperSelectField/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import "DesignSystem/Fonts/Inter-500.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaSuperSelectOptions from 'DesignSystem/TysiaSuperSelect/TysiaSuperSelectOptions/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSuperSelectField({
  children,
  viewPath = "/DesignSystem/TysiaSuperSelect/TysiaSuperSelectField",
  autoComplete = "off",
  autoFocus,
  type = "search",
  placeholder,
  onChangeFilter,
  onBlur,
  onFocus,
  onKeyUp,
  valueFilter,
  disabled,
  isShowingOptions,
  optionsRef,
  from,
  id,
  onClick,
  isSelected,
  size,
  optionsHeight = "auto",
  optionsWidth = "auto"
  
}) {
let dtTysiainputfieldColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.base'
        })
let dtTysiainputfieldColorPrimaryPlaceholder = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.placeholder'
        })
let dtTysiainputfieldColorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.hovered'
        })
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="TysiaSuperSelectField.Capture"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 placeholder={placeholder}
 onChange={(e) => onChangeFilter && onChangeFilter(e, e.target.value)}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={valueFilter}
 disabled={disabled}
 style={{'--c-1-QUY9Y': disabled ? dtTysiainputfieldColorPrimaryHovered : dtTysiainputfieldColorPrimaryBase,'--bs-2-QUY9Y': disabled ? "0 0" : "16px 12px",'--c-3-QUY9Y': disabled ? "default" : "pointer"}}
 className={`views-capture ${styles.Capture}`}
/>
<fromFlow.When is={isShowingOptions}>
<TysiaSuperSelectOptions
  viewPath={`${viewPath}/TysiaSuperSelectOptions`}
 innerRef={optionsRef}
 from={from}
 id={id}
 onClick={onClick}
 isSelected={isSelected}
 size={size}
 disabled={disabled}
 height={optionsHeight}
 width={optionsWidth}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}